<template>
    <router-view/>
</template>
<script>
export default {
    name:'sale-layout'
}
</script>